import React from 'react';
import { useState } from 'react';
import { IdleTimerProvider, useIdleTimer } from 'react-idle-timer';
import { useUIControlsStore } from '../../redux/features/ui-controls';
import IdleTimerSessionModal from './idle-timer-session-modal';
import { useAuthStore } from '../../redux';

const IdleTimerParent = ({ children }) => {
  // 20 minutes timedown for session expire
  const timeoutFixedValue = 60000 * 20;

  //Local State to handle timeout
  const [timeout, setTimeout] = useState(timeoutFixedValue);

  const { updateShowSessionExpiredModal } = useUIControlsStore();

  const { customerId, customerRefNum, Authorization } = useAuthStore();

  const onIdle = () => {
    //Clear seession storage in this function
    if (customerId && customerRefNum && Authorization) {
      // updateShowSessionExpiredModal(true);
    }
  };

  return (
    <IdleTimerProvider
      timeout={timeout}
      onIdle={onIdle}
      element={document}
      debounce={250}
      eventsThrottle={200}
    >
      <IdleTimerSessionModal />
      {children}
    </IdleTimerProvider>
  );
};

export default IdleTimerParent;
